import { Spin } from 'antd';
import ApiClient from 'networking/fetch';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useStore } from 'store/store';
const subEntityNames = [
  'overall',
  'country',
  'state',
  'district',
  'block',
  'cluster',
  'school_group',
  'school_id',
];
function Verify() {
  const history = useHistory();
  const [setUserData] = useStore((state) => [state.setUserData]);
  const [errorMessage, setErrorMessage] = useState<any>(null);
  function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const query = useQuery();
  let token = query.has('TokenValues') ? query.get('TokenValues') : null;
  const devMode = query.has('devMode') ? true : false;
  if (token) {
    window.sessionStorage.setItem(
      'pastToken',
      JSON.stringify({ token: token, time: new Date().getTime() })
    );
  } else {
    const pastToken = window.sessionStorage.getItem('pastToken');
    if (pastToken) {
      const parsedToken = JSON.parse(pastToken);
      if (parsedToken) {
        token = parsedToken.token;
      }
    }
  }
  useEffect(() => {
    if (devMode) {
      const verificationData = {
        data: {
          JSON: {
            valid: 'true',
            userName: 'Vedany Sir Jee',
            role: 'ReportManager',
            entity: 'state',
          },
          acesss: {
            names: ['Himachal Pradesh'],
          },
        },
      };
      const basePathData = { basePath: [] };
      setUserData({ ...verificationData, ...basePathData });
      history.push(`/dashboard/${basePathData.basePath.join('/')}`);
    }
    if (token) {
      ApiClient.get(`${process.env.REACT_APP_BACKEND_URL}/verification`, {
        token,
      })
        .then((userResponse) => {
          if (userResponse.status >= 200 && userResponse.status < 400) {
            const userData = userResponse.data;
            if (
              userData &&
              userData.JSON.valid &&
              subEntityNames.includes(userData.JSON.entity) &&
              userData.acesss.names.length > 0
            ) {
              const entity = userData.JSON.entity;
              const name = userData.acesss && userData.acesss.names[0];
              ApiClient.get(`${process.env.REACT_APP_BACKEND_URL}/base-url`, {
                entity,
                name,
              }).then((response) => {
                if (response.status >= 200 && response.status < 400) {
                  setUserData({ ...userResponse, ...response.data });
                  history.push(
                    `/dashboard/${response.data.basePath.join('/')}`
                  );
                }
              });
            } else {
              setErrorMessage('Entity or name is missing...');
            }
          } else {
            setErrorMessage('User token invalid...');
          }
        })
        .catch((error) => {
          setErrorMessage(error.message);
        });
    } else {
      setErrorMessage('Token is missing...');
    }
  }, [history, setUserData, setErrorMessage, devMode]);
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'grid',
        placeItems: 'center',
      }}
    >
      {errorMessage ? errorMessage : <Spin></Spin>}
    </div>
  );
}

export default Verify;
